/*eslint eqeqeq: "off"*/
/*eslint no-unused-vars: "off"*/
/*eslint no-useless-escape: "off"*/


import React, { Component } from 'react'
import { Link } from 'react-router'
import NavBar from './../../ui/template/NavBar'
import SortableTree, { removeNodeAtPath, addNodeUnderParent } from 'react-sortable-tree';
import 'react-sortable-tree/style.css'; // This only needs to be imported once in your app
import firebase, { app } from '../../config/database'
import Config from '../../config/app';
import SectionConfig from '../../config/builder/sections_config';
import { Image } from '../../components/fields'
import Notification from '../../components/Notification';
import SkyLight from 'react-skylight';
import Wizzard from './../../ui/template/Wizzard';
import Input from '../../components/fields/Input'
import T from './../../translations/translate'
import { connect } from 'react-redux';
import HTML from '../../components/fields/HTML_forspeaker';
import update from 'react-addons-update'; // ES6
import Imagemapcomponent from './Imagemapcomponent';
var _ = require('lodash');
import ReactTable from "react-table"
import "react-table/react-table.css"
import components from '../../config/builder/components'
const ConditionalDisplay = ({ condition, children }) => condition ? children : <div></div>;
const getNodeKey = ({ node }) => node.key;
function MyCell({ value }) {
  return <a  >{value}1</a>
}
class Imagemap extends Component {
  constructor(props) {
    super(props);

    this.state = {
      treeData: [],
      showAddButton: false,
      pathToDelete: "",
      nodeToDelete: { name: "" },
      inputDelete: "",

      sectionsactive: ["active", ""],
      speakername: "",
      speakerpost: "",
      speakercompany: "",
      speakerimage: "./assets/img/profile.jpg",
      speakerdes: "",
      columns: [],
      tdata: [],
      updatedspeaker: false,
      selectedspeaker: {}
    };

    // this.processDataForShowing = this.processDataForShowing.bind(this);
    this.cancelDelete = this.cancelDelete.bind(this);
    this.doDelete = this.doDelete.bind(this);
    this.appKey = "";

    // this.checkIfCanDeleteApp = this.checkIfCanDeleteApp.bind(this);
  }




  generateNotifications(item) {
    return (
      <div className="col-md-12">
        <Notification type={item.type} >{item.content}</Notification>
      </div>
    )
  }
  savetoreduxandfirebase() {
    var data = this.processdataforfirebase(this.state.treeData);
    firebase.app.database().ref('myapps/' + this.props.params.sub + "/infobooths").set(data);
    this.props.updateobjectwithtracks({ eventkey: this.props.params.sub, type: 'infobooths', data: data });
  }
  doedit(d) {
    console.log("in edit");
    var key = this.state.selectedspeaker.key;

    console.log(d);
    console.log("Update redux state");
    this.props.updatedataobjectbytype({ eventkey: this.props.params.sub, type: this.props.route.type, key: key, data: d })
    console.log("Updating local state");
    this.setState({
      tdata: this.state.tdata.map(el => (el.key === key ? { ...el, ...d } : el))
    }, () => {
      console.log(this.state.tdata);
    });
    console.log("Saving to firebase");
    if (d.company == "") {
      delete d.company;
    }
    if (d.post == "") {
      delete d.post;
    }
    if (d.des == "") {
      delete d.des;
    }
    console.log(d);
    firebase.app.database().ref('myapps/' + this.props.params.sub + "/" + this.props.route.type + "/" + key).update(d);

    this.gotomainlist();

  }
  doDelete() {
    console.log("Do delete ");
    console.log(this.state.selectedspeaker);
    var key = this.state.selectedspeaker.key;
    console.log("Update redux state");
    this.props.updatedataobjectbytype({ eventkey: this.props.params.sub, type: this.props.route.type, key: key, data: undefined })
    console.log("Updating local state");
    this.setState({
      tdata: this.state.tdata.filter(el => (el.key === key ? false : true))
    }, () => {
      console.log(this.state.tdata);
    });
    firebase.app.database().ref('myapps/' + this.props.params.sub + "/" + this.props.route.type + "/" + key).set(null);

    // this.setState({
    //   treeData: nodes
    // }, () => {
    //   console.log("DOne");
    //   console.log(this.state.treeData);
    //   this.savetoreduxandfirebase();
    // });
    this.refs.deleteDialog.hide()
  }


  cancelDelete() {
    console.log("Cancel Delete");
    this.refs.deleteDialog.hide()
  }

  getSlug() {
    var lastIndex = Config.appEditPath.lastIndexOf("/");
    lastIndex++;
    var slug = Config.appEditPath.substring(lastIndex);
    return slug;
  }


  getObjectDiff(obj1, obj2) {
    const diff = Object.keys(obj1).reduce((result, key) => {
      if (!obj2.hasOwnProperty(key)) {
        result.push(key);
      } else if (_.isEqual(obj1[key], obj2[key])) {
        const resultKeyIndex = result.indexOf(key);
        result.splice(resultKeyIndex, 1);
      }
      return result;
    }, Object.keys(obj2));

    return diff;
  }
  processdataforfirebase(data) {
    var tracks = {};
    var infobooths = {};
    for (let index = 0; index < data.length; index++) {
      tracks[data[index].key] = {
        name: data[index].title,
        o: index
      }
      if (data[index].children) {
        for (let j = 0; j < data[index].children.length; j++) {
          var d = data[index].children[j];
          var infobooth = {};
          infobooth.name = d.title;
          infobooth.o = j;
          infobooth.des = d.des;
          infobooth.track = data[index].key;
          infobooths[d.key] = infobooth;
        }
      }
    }
    return { tracks: tracks, infobooth: infobooths };
  }


  sectionTabContent(treeData) {
    // var data = JSON.parse(JSON.stringify(treeData))
    return (
      // <div/>
      <Imagemapcomponent locationdata={this.state.locationdata} />
    )
  }





  wizzardsectionchange = () => {
    console.log("Section changed");
    this.setState({
      speakername: "",
      speakerpost: "",
      speakercompany: "",
      speakerimage: "./assets/img/profile.jpg",
      speakerdes: "",
      selectedspeaker: {},
      updatedspeaker: false,


      locationdata: []
    })
  }

  componentWillMount() {
    if (this.props.events[this.props.params.sub]) {
      if (this.props.events[this.props.params.sub].location) {
        var locationdata = JSON.parse(JSON.stringify(this.props.events[this.props.params.sub].location));
        console.log(locationdata);
        var ldata = [];
        Object.keys(locationdata).map(ld => {
          ldata.push({
            label:locationdata[ld].name,
            value:ld
          })
        })
        this.setState({
          locationdata: ldata
        },()=>{
          console.log(this.state.locationdata);
        });
      }
    }
  }
  gotomainlist() {
    this.setState({
      sectionsactive: ["active", ""],
      selectedspeaker: {},
      speakername: "",
      speakerpost: "",
      speakerimage: "./assets/img/profile.jpg",
      speakercompany: "",
      speakerdes: ""
    })
  }
  addspeaker() {

    return (
      <div></div>
    )
  }
  capitalize = (s) => {
    if (typeof s !== 'string') return ''
    return s.charAt(0).toUpperCase() + s.slice(1)
  }
  render() {
    var theSteps = [
      {
        name: "sections",
        icon: "subject",
        title: T.td(this.capitalize(this.props.route.type)),
        active: this.state.sectionsactive[0],
        label1: T.ts(this.capitalize(this.props.route.type) + " List"),
        label2: T.ts("Please click save once done"),
        content: this.sectionTabContent(this.state.treeData)
      }, {
        name: "images",
        icon: "collections",
        title: T.td("Add " + this.props.route.name),
        active: this.state.sectionsactive[1],
        label1: T.td("Add " + this.props.route.name),
        content: this.addspeaker()
      }
    ];

    return (
      <div>
        <SkyLight hideOnOverlayClicked ref="deleteDialog" title="">
          <span><h3 className="center-block">{T.ts("Delete section")}</h3></span>
          <div className="col-md-12">
            <Notification type="danger" >{T.ts("All data at this location incuding nested sections will be deleted")}!</Notification>
          </div>
          <div className="col-md-12">
            {T.td(this.props.route.name + " name")}
          </div>
          <div className="col-md-12">
            <b>{this.state.selectedspeaker.name}</b>
          </div>

          <div className="col-sm-12" style={{ marginTop: 80 }}>
            <div className="col-sm-6">
            </div>
            <div className="col-sm-3 center-block">
              <a onClick={this.cancelDelete} className="btn btn-info center-block">{T.td("Cancel")}</a>
            </div>
            <div className="col-sm-3 center-block">
              <a onClick={() => this.doDelete()} className="btn btn-danger center-block">{T.td("Delete")}</a>
            </div>

          </div>

        </SkyLight>

        <div className="main-panel col-md-12">
          <NavBar currentLangData={this.props.route.currentLangData}></NavBar>


          <Wizzard
            title={this.capitalize(this.props.route.type)}
            steps={theSteps}
            stepsActivity={this.state.sectionsactive}
            wizzardsectionchange={this.wizzardsectionchange}
          />

        </div>
      </div>)

  }
}

const mapStateToProps = state => ({
  events: state.eventmodel.mainappdata.events
})

const mapDispatchToProps = dispatch => ({
  addnewsection: dispatch.eventmodel.addnewsection,
  updatedataobjectbytype: dispatch.eventmodel.updatedataobjectbytype,
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Imagemap);


// WEBPACK FOOTER //
// ./src/containers/Builder/Imagemap.js